import upperFirst from "lodash/upperFirst";
import { TriangleAlert, X } from "lucide-react";
import React from "react";
import { cn } from "@shared/ui";

export const lookupStatusConfig = (status: string) => {
  switch (status) {
    case "warning":
      return {
        icon: TriangleAlert,
        color: "border-warning-border bg-warning-bg text-warning-fg",
        height: "h-3",
        width: "w-3",
      };
    case "caution":
      return {
        icon: X,
        color: "border-danger-border bg-fail-bg text-danger-ink",
        height: "h-3",
        width: "w-3",
      };
    default:
      return {
        icon: null,
        color: "border-subtle bg-surface-muted text-ink-secondary",
        height: "h-3",
        width: "w-3",
      };
  }
};

interface StatusBadgeProps {
  status: "caution";
  withIcon?: boolean;
}

const Badge = ({ status, withIcon = true }: StatusBadgeProps) => {
  const statusConfig = lookupStatusConfig(status);
  const badgeText = status ? upperFirst(status) : "Unknown";
  const StatusIcon = statusConfig.icon;

  return (
    <div
      className={cn(
        "flex max-w-fit shrink-0 items-center gap-x-1 rounded-full border px-2 py-0.5",
        statusConfig.color
      )}
    >
      {withIcon && StatusIcon && (
        <StatusIcon
          aria-hidden
          strokeWidth={2.25}
          className={cn("shrink-0", statusConfig.height, statusConfig.width)}
        />
      )}
      {status && <p className="text-small-medium">{badgeText}</p>}
    </div>
  );
};

export default Badge;
